export const isIE = () => {
  const userAgent = window.navigator.userAgent;
  const isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1;
  const isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
  const isEdge = userAgent.indexOf('Edge') > -1 && !isIE;
  return isIE || isIE11;
};



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-plugin/util/index.js